import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from './en.js'
import jp from './jp.js'
import idr from './idr.js'

Vue.use(VueI18n)

// ⭐ 优先读本地
let lang = localStorage.getItem('lang')

if (!lang) {
  // const browserLang = navigator.language.toLowerCase()
  // ⭐ 只判断日语
  // if (browserLang.includes('ja')) {
  //   lang = 'jp'
  // } else {
  //   lang = 'en'
  // }
  lang = 'idr'

  // 写入本地
  localStorage.setItem('lang', lang)
}

const messages = {
  en,
  jp,
  idr
}

const i18n = new VueI18n({
  locale: lang,
  fallbackLocale: lang,
  messages
})

export default i18n